import React, { useState } from 'react';
import apiClient from '../../../utils/apiclient';

const AddBbCoins = () => {
  const isAdmin = localStorage.getItem("bentoAdminDetails") == 4 ? true : false;

  const [formData, setFormData] = useState({
    user_id: '',
    amount: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    try {
      const { user_id, amount } = formData;
      await apiClient.post(`/add/BBcoins/${user_id}/${amount}`, {

      });
      alert('BB Coins added successfully');


    } catch (error) {
      alert('Failed to add BB Coins');
      console.error('Error submitting form:', error);
    }
  };

  return (
    <div className="w-full flex-1 flex flex-col min-h-0 mt-4 overflow-auto px-2 md:px-4">
      {isAdmin && (
        <form onSubmit={handleSubmit} className="w-full max-w-4xl bg-white border border-gray-300 shadow-sm">
          <div className="bg-gray-800 text-white px-4 py-2 sticky top-0 z-10 shadow-md">
            <h2 className="text-sm md:text-base font-bold">Add BB Coins</h2>
          </div>

          <div className="p-3 md:p-5 flex flex-col gap-4">
            <div className="flex flex-col md:flex-row gap-4">
              <div className="flex flex-col md:flex-row gap-2 md:items-center flex-1">
                <label className="text-[10px] md:text-sm font-semibold w-24 flex-shrink-0 text-gray-700">User ID</label>
                <input
                  type="number"
                  name="user_id"
                  placeholder="Enter User ID"
                  value={formData.user_id}
                  onChange={handleChange}
                  required
                  className="flex-1 px-2 py-1 text-[10px] md:text-sm border border-gray-400 rounded focus:outline-none focus:border-blue-500"
                />
              </div>
              <div className="flex flex-col md:flex-row gap-2 md:items-center flex-1">
                <label className="text-[10px] md:text-sm font-semibold md:w-20 flex-shrink-0 text-gray-700">Amount</label>
                <input
                  type="number"
                  name="amount"
                  placeholder="Enter Amount"
                  value={formData.amount}
                  onChange={handleChange}
                  required
                  className="flex-1 px-2 py-1 text-[10px] md:text-sm border border-gray-400 rounded focus:outline-none focus:border-blue-500"
                />
              </div>
            </div>

            <div className="mt-4 flex justify-end">
              <button
                type="submit"
                className="w-full md:w-auto bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-6 rounded transition"
              >
                Add Coins
              </button>
            </div>
          </div>
        </form>
      )}
    </div>
  );
};

export default AddBbCoins;